export type RumPageNameFormatter = (url: string, serviceName: string) => string

const NO_DATA = 'unknown'

const __DEV__ = process.env.NODE_ENV === 'development'

const wordRE = new RegExp('^[a-z-_]+$')

const isNumeric = (str: string | number) => str === Number(str)

const uuidLike = (str: string) => /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-/i.test(str)

const hasNumber = (str: string) => /[0-9]/.test(str)

const tooLong = (str: string) => str.length >= 32

const notWordLike = (str: string) => wordRE.test(str) === false

export const isDynamicRumSegment = (segment: string, customFilter?: (segment: string) => boolean): boolean =>
  [isNumeric, uuidLike, hasNumber, tooLong, notWordLike].concat(customFilter || []).some(f => f(segment))

// TODO: После миграции объеденить с `NODE_formatRumPageName()`
export const BROWSER_formatRumPageName = (
  locationPathname: string,
  serviceName: string,
  options: {customFilter?: (path: string) => boolean} | undefined = {},
): string => {
  let somePathsWereFiltered = false
  let pagePaths = locationPathname.substring(1).split('/').filter(Boolean)

  if (!__DEV__) {
    pagePaths.shift() // Ref: config.basename
  }

  if (serviceName === 'route') {
    pagePaths = ['index']
  } else if (serviceName === 'account2') {
    serviceName = 'account'
  }

  return serviceName.concat(
    '.',
    pagePaths.filter(Boolean).filter(p => {
      const found = isDynamicRumSegment(p, options.customFilter)

      if (found && !somePathsWereFiltered) {
        somePathsWereFiltered = true
      }

      return !found
    })[0] || (somePathsWereFiltered ? NO_DATA : 'index'),
  )
}

export const getRumPageNameFormatter = (formatPageName?: RumPageNameFormatter): RumPageNameFormatter =>
  formatPageName || BROWSER_formatRumPageName
